import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { unicodeCharacters } from '../../utils/constants';
export const useTableList = ({ list, maxLabelLength, maxItems }) => {
    const getDisplayLabel = useCallback((label) => (label === null || label === void 0 ? void 0 : label.length) > maxLabelLength
        ? `${label === null || label === void 0 ? void 0 : label.substr(0, maxLabelLength)}${unicodeCharacters.THREE_DOTS}`
        : label, [maxLabelLength]);
    const visibleList = useMemo(() => (maxItems ? list === null || list === void 0 ? void 0 : list.slice(0, maxItems) : list), [list, maxItems]);
    const hiddenList = useMemo(() => (maxItems ? list === null || list === void 0 ? void 0 : list.slice(maxItems, list === null || list === void 0 ? void 0 : list.length) : []), [list, maxItems]);
    const moreInfoTooltip = useMemo(() => (hiddenList === null || hiddenList === void 0 ? void 0 : hiddenList.length) > 0
        ? hiddenList === null || hiddenList === void 0 ? void 0 : hiddenList.map((el, i) => (_jsxs("div", { children: [el, i === (hiddenList === null || hiddenList === void 0 ? void 0 : hiddenList.length) - 1 ? '' : ','] }, `${el}-${i}`)))
        : '', [hiddenList]);
    const value = useMemo(() => ({
        getDisplayLabel,
        visibleList,
        hiddenList,
        moreInfoTooltip,
    }), [getDisplayLabel, hiddenList, moreInfoTooltip, visibleList]);
    return value;
};
